<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import ComponentAveragesTable from '@/components/ComponentAveragesTable';
import { mapGetters } from 'vuex';
import axios from 'axios'

import DashboardHeading from '@/components/DashboardHeading'
import DashboardText from '@/components/DashboardText'
import ComponentAveragesChartContainer from '@/components/ComponentAveragesChartContainer'
import { filterObservations, createTeacherObjects, createComments } from '@/helpers/storeHelper'

import { mappings } from '@/helpers/mappingsHelper'
import { teacherDashboardHelper } from '@/helpers/teacherDashboardHelper'
import { onboardingHelper } from '@/helpers/onboardingHelper'

import EventBus from '@/event-bus'

import store from '@/store'

const apiBase = API_APP_PATH + "/v1"

@Component({
    components: {
        ComponentAveragesTable,
        DashboardHeading,
        DashboardText,
        ComponentAveragesChartContainer
    },
    computed: {
        ...mapGetters({
          userRole: "getUserRole"
        }),
        teacherName() {
            return `${this.teacherInfo[0].FirstName} ${this.teacherInfo[0].LastName}`
        }
    }   
})

export default class TeacherDashboardContainer extends Vue {
    id = null
    dashboardType = 'adminTeacher'
    teacherInfo = null
    componentsInfo = null
    loading = false
    steps = teacherDashboardHelper().adminSteps

    created () {
        store.commit('currentPage', 'teacher-dashboard')
    }

    mounted () {
        EventBus.$on('start intro', () => {
            this.startIntro()
        })
        EventBus.$on('loading', () => {
            this.loading = true
        })

        this.$nextTick(() => {
            if (localStorage.getItem('doneTeacherDashboardOnboarding')) {
                return
            } else {
                setTimeout(() => {
                    this.startIntro();
                }, 1000)
            }
        })
        
        this.id = this.$route.params.id

        this.loading = true

        return new Promise((resolve, reject) => {

            const yearsEvaluated = axios.get(`${apiBase}/data/teacher/app/ge/info/id/${this.id}`)
            const components = axios.get(`${apiBase}/data/teacher/component/${this.id}`)
            const observations = axios.get(`${apiBase}/data/teacher/observations/${this.id}`)

            Promise.all([yearsEvaluated, components, observations]).then( data => {

                const [_yearsEvaluated, _components, _observations] = data

                filterObservations(_observations.data, _components)

                this.teacherInfo = _yearsEvaluated['data']

                this.componentsInfo = createTeacherObjects(this.teacherInfo, mappings, _components['data'], _observations['data'])

            this.loading = false

            resolve(true)

            })
        })
    }

    startIntro() {
        onboardingHelper().startIntro(
            introJs(), this, 'doneTeacherDashboardOnboarding'
        )
    }
        
}

</script>

<template>
    <div v-loading="loading"
        v-loading.fullscreen.lock="loading"
        element-loading-text="Loading...">
        <div 
            v-if="componentsInfo"
        >
            <DashboardHeading
                :userRole="userRole"
                :dashboardType="dashboardType"
                :teacherName="teacherName">
            </DashboardHeading>

            <ComponentAveragesTable v-loading="loading"
                :teacherInfo="teacherInfo"
                :userRole="userRole"
                :teacherComponents="componentsInfo">   
            </ComponentAveragesTable>

            <DashboardText/>

            <div class="chart-container">
                <ComponentAveragesChartContainer
                    :componentsInfo="componentsInfo">
                </ComponentAveragesChartContainer>
            </div>

        </div>
    </div>

</template>

<style lang="scss" scoped>
    .chart-container {
        margin-top: 50px;
    }
</style>
